import { NgModule } from '@angular/core';
import { COMPANY_FEATURE_LAZY, COMPANY_UI_LAZY } from '@company/const';
import { CompanyCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        [COMPANY_FEATURE_LAZY]: {
          module: () => import('./sdvor-company-feature-lazy.module').then((m) => m.SdvorCompanyLazyModule),
        },
        [COMPANY_UI_LAZY]: {
          module: () => import('./sdvor-company-ui-lazy.module').then((m) => m.SdvorCompanyLazyModule),
          cmsComponents: Object.values(CompanyCmsComponents),
        },
      },
    }),
  ],
})
export class SdvorCompanyShellModule {}
